import "src/decidim/budgets/projects";
import "src/decidim/budgets/progressFixed";
import "src/decidim/budgets/exit_handler";
import "src/decidim/budgets/budgetSummaryBackdrop";
require.context("../images", true);
import "stylesheets/budgets.scss";
